import { render, staticRenderFns } from "./server-list.vue?vue&type=template&id=f382c3d0&scoped=true&"
import script from "./server-list.vue?vue&type=script&lang=js&"
export * from "./server-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f382c3d0",
  null
  
)

export default component.exports